import { CarrierLogisticsWebServerClientConfigFactory } from "@amzn/coral-config_carrier-logistics-web-server";
import { CoralClientFactory, CoralFetchHandler, InterceptingHandler } from "@amzn/ihm-js-coral-client";
import { carrierLogisticsWebServerHttpBindingInterceptor, CarrierLogisticsWebServer } from "@amzn/coral_com-amazon-carrierlogisticswebserver-model";
import RequestOptionsInterceptor from "./RequestOptionsInterceptor";
import envHelper from "../config/env";
var clientFactory = new CoralClientFactory([
    CarrierLogisticsWebServerClientConfigFactory
], envHelper.getEnv(), new InterceptingHandler(new CoralFetchHandler(), [
    carrierLogisticsWebServerHttpBindingInterceptor,
    new RequestOptionsInterceptor()
]));
var CarrierLogisticsWebServerClient = clientFactory.get(CarrierLogisticsWebServer);
export default CarrierLogisticsWebServerClient;

//# sourceMappingURL=CarrierLogisticsWebServerClient.js.map